// Minimal logger shim for the component — maps to console with safe checks
const levels = ['debug', 'info', 'warn', 'error'];
const logger = {};
levels.forEach(l => { logger[l] = console[l] ? console[l].bind(console) : console.log.bind(console); });
export default logger;
